import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async (userId, {perPage = 10, page = 0}) => {
  const qb = RequestQueryBuilder.create();

  qb.setFilter({ field: "user.id", operator: "$eq", value: userId });
  qb.sortBy({field: 'createdAt', order: "DESC"});

  qb.setPage(page);
  qb.setLimit(perPage);
  qb.setOffset(perPage * page);

  const response = await Http.get('admin/user/notes', {
    params: qb.queryObject
  });

  return response.data;
}
